function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1948(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 34.8,
    height: 19.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.42375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 9.695,
    fontFamily: "Arial"
  }, "\n        Florence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.39,
    width: 34.8,
    height: 30.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0920000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 34.620000000000005,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.85,
    width: 34.8,
    height: 30.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.098
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 65.095,
    fontFamily: "Arial"
  }, "\n        Pepin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.34,
    width: 34.8,
    height: 34.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8666666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 97.80000000000001,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.26,
    width: 34.8,
    height: 39.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 134.91,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 154.56,
    width: 34.8,
    height: 43.01,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.971428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 176.065,
    fontFamily: "Arial"
  }, "\n        Burnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 197.57,
    width: 34.8,
    height: 46.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 220.785,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 244,
    width: 34.8,
    height: 50.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 269.145,
    fontFamily: "Arial"
  }, "\n        Sawyer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 294.29,
    width: 34.8,
    height: 50.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 319.5,
    fontFamily: "Arial"
  }, "\n        Vilas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 344.71,
    width: 34.8,
    height: 54.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 371.875,
    fontFamily: "Arial"
  }, "\n        Washburn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 399.04,
    width: 34.8,
    height: 55.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.971428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 426.58000000000004,
    fontFamily: "Arial"
  }, "\n        Buffalo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 454.11,
    width: 34.8,
    height: 56.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 482.59000000000003,
    fontFamily: "Arial"
  }, "\n        Waushara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 511.08,
    width: 34.8,
    height: 61.36,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.971428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 541.76,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 572.44,
    width: 34.8,
    height: 63.2,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4799999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 604.0400000000001,
    fontFamily: "Arial"
  }, "\n        Green_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 635.64,
    width: 34.8,
    height: 64.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.4,
    y: 667.8199999999999,
    fontFamily: "Arial"
  }, "\n        Bayfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 0,
    width: 44.67,
    height: 52.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.135,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.47,
    y: 0,
    width: 45.51,
    height: 52.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.3775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.225,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Rusk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.98,
    y: 0,
    width: 47.25,
    height: 52.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.90625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.60500000000002,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Kewaunee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.23,
    y: 0,
    width: 49.49,
    height: 52.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.898
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.975,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Price\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.73,
    y: 0,
    width: 49.67,
    height: 52.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.278333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.565,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Juneau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.39,
    y: 0,
    width: 50.37,
    height: 52.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.29625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.575,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.77,
    y: 0,
    width: 50.4,
    height: 52.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.96999999999997,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Calumet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.16,
    y: 0,
    width: 51.82,
    height: 52.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.757777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 398.07000000000005,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.98,
    y: 0,
    width: 52.41,
    height: 52.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.55125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.185,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.39,
    y: 0,
    width: 54.41,
    height: 52.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.1575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 503.59499999999997,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Door\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.8,
    y: 0,
    width: 54.77,
    height: 52.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.518571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 558.185,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585.57,
    y: 0,
    width: 56.85,
    height: 52.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.1575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 613.995,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Iowa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.42,
    y: 0,
    width: 57.58,
    height: 52.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.518571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.2099999999999,
    y: 26.315,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 52.63,
    width: 58.49,
    height: 52.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.768333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 78.935,
    fontFamily: "Arial"
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 105.24,
    width: 58.49,
    height: 53.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 131.76,
    fontFamily: "Arial"
  }, "\n        Langlade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 158.28,
    width: 58.49,
    height: 54.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.086666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 185.54,
    fontFamily: "Arial"
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 212.79,
    width: 58.49,
    height: 55.12,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.024
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 240.35,
    fontFamily: "Arial"
  }, "\n        Green\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 267.91,
    width: 58.49,
    height: 55.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 295.685,
    fontFamily: "Arial"
  }, "\n        Trempealeau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 323.46,
    width: 58.49,
    height: 60.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.355714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 353.67999999999995,
    fontFamily: "Arial"
  }, "\n        Ozaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 383.9,
    width: 58.49,
    height: 60.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.748333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 414.245,
    fontFamily: "Arial"
  }, "\n        Oconto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 444.59,
    width: 58.49,
    height: 61.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.6225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 475.38,
    fontFamily: "Arial"
  }, "\n        Dunn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 506.17,
    width: 58.49,
    height: 62.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.748333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 537.25,
    fontFamily: "Arial"
  }, "\n        Vernon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 568.32,
    width: 58.49,
    height: 62.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.6225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 599.735,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 631.15,
    width: 58.49,
    height: 68.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.748333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.045,
    y: 665.5749999999999,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.29,
    y: 52.63,
    width: 60.36,
    height: 67.79,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.622857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.47,
    y: 86.525,
    fontFamily: "Arial"
  }, "\n        Shawano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.65,
    y: 52.63,
    width: 60.6,
    height: 67.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.95000000000002,
    y: 86.525,
    fontFamily: "Arial"
  }, "\n        St._Croix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.25,
    y: 52.63,
    width: 63.28,
    height: 67.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.656
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.89,
    y: 86.525,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.53,
    y: 52.63,
    width: 65.49,
    height: 67.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5489999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.275,
    y: 86.525,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.02,
    y: 52.63,
    width: 68.04,
    height: 67.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.298333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.03999999999996,
    y: 86.525,
    fontFamily: "Arial"
  }, "\n        Barron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.07,
    y: 52.63,
    width: 68.91,
    height: 67.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.47375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.525,
    y: 86.525,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.98,
    y: 52.63,
    width: 71.15,
    height: 67.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.532222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.5550000000001,
    y: 86.525,
    fontFamily: "Arial"
  }, "\n        Marinette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.13,
    y: 52.63,
    width: 73.51,
    height: 67.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.684285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.885,
    y: 86.525,
    fontFamily: "Arial"
  }, "\n        Waupaca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.65,
    y: 52.63,
    width: 75.35,
    height: 67.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.9475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.3249999999999,
    y: 86.525,
    fontFamily: "Arial"
  }, "\n        Sauk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.29,
    y: 120.43,
    width: 72.3,
    height: 73.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.328571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.44,
    y: 157.04500000000002,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.29,
    y: 193.66,
    width: 72.3,
    height: 74.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.44,
    y: 231.1,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.29,
    y: 268.53,
    width: 72.3,
    height: 80.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.459999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.44,
    y: 308.59,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.29,
    y: 348.66,
    width: 72.3,
    height: 83.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.033333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.44,
    y: 390.415,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.29,
    y: 432.17,
    width: 72.3,
    height: 85.76,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.44,
    y: 475.05,
    fontFamily: "Arial"
  }, "\n        Walworth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.29,
    y: 517.93,
    width: 72.3,
    height: 86.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.44,
    y: 561.0649999999999,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.29,
    y: 604.2,
    width: 72.3,
    height: 95.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2299999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.44,
    y: 652.1,
    fontFamily: "Arial"
  }, "\n        Eau_Claire\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 120.43,
    width: 73.5,
    height: 98.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.35,
    y: 169.625,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.1,
    y: 120.43,
    width: 75.1,
    height: 98.39,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.728571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.65,
    y: 169.625,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 120.43,
    width: 90.06,
    height: 98.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.187272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.23,
    y: 169.625,
    fontFamily: "Arial"
  }, "\n        Fond_du_Lac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.26,
    y: 120.43,
    width: 90.76,
    height: 98.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.084444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.64,
    y: 169.625,
    fontFamily: "Arial"
  }, "\n        La_Crosse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.02,
    y: 120.43,
    width: 97.01,
    height: 98.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.77888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.525,
    y: 169.625,
    fontFamily: "Arial"
  }, "\n        Manitowoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.03,
    y: 120.43,
    width: 107.97,
    height: 98.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.932222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.015,
    y: 169.625,
    fontFamily: "Arial"
  }, "\n        Outagamie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 218.82,
    width: 95.81,
    height: 112.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.97625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.505,
    y: 275.08,
    fontFamily: "Arial"
  }, "\n        Marathon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 331.34,
    width: 95.81,
    height: 115.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.645555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.505,
    y: 389.325,
    fontFamily: "Arial"
  }, "\n        Sheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 447.31,
    width: 95.81,
    height: 124.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.645555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.505,
    y: 509.64,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 571.97,
    width: 95.81,
    height: 128.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.97625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.505,
    y: 635.985,
    fontFamily: "Arial"
  }, "\n        Waukesha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.4,
    y: 218.82,
    width: 96.36,
    height: 127.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.765714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.58,
    y: 282.78499999999997,
    fontFamily: "Arial"
  }, "\n        Kenosha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.76,
    y: 218.82,
    width: 101.11,
    height: 127.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.2775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.315,
    y: 282.78499999999997,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 458.86,
    y: 218.82,
    width: 109.71,
    height: 127.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.942
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.715,
    y: 282.78499999999997,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.57,
    y: 218.82,
    width: 131.43,
    height: 127.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.32166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.2850000000001,
    y: 282.78499999999997,
    fontFamily: "Arial"
  }, "\n        Racine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.4,
    y: 346.75,
    width: 65.93,
    height: 353.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.365,
    y: 523.375,
    fontFamily: "Arial"
  }, "\n        Dane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.33,
    y: 346.75,
    width: 372.67,
    height: 353.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.665,
    y: 523.375,
    fontFamily: "Arial"
  }, "\n        Milwaukee\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1948);
export default __webpack_public_path__ + "static/media/1948.0286309fc8d2aa562811f3882f773c50.svg";
export { ForwardRef as ReactComponent };